import { createResponsesImage } from '../createResponsesImage/createResponsesImage';
import component from './ResponsesImageConnectionErrorSvg';

export const ResponsesImageConnectionError = createResponsesImage({
  name: 'ResponsesImageConnectionError',
  component,
});
